<template>
  <el-dialog
    title="脚本编辑"
    :visible.sync="state"
    width="40%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <!-- <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form> -->
    <el-form
      :model="formData"
      label-width="110px"
      ref="formData"
      :rules="rules"
    >
      <el-form-item label="脚本名称" prop="scriptName">
        <el-input v-model="formData.scriptName"></el-input>
      </el-form-item>

      <el-form-item label="脚本示例" prop="inputExample">
        <el-input v-model="formData.inputExample"></el-input>
      </el-form-item>
      <el-form-item label="脚本内容" prop="scriptBody">
        <!-- <el-input v-model="formData.inputExample" ></el-input> -->
        <prism-editor
          class="my-editor height-300"
          v-model="formData.scriptBody"
          :highlight="highlighter"
          @change="codeChanged"
          :line-numbers="lineNumbers"
        ></prism-editor>
        <div style="margin-left: 20px" v-if="testResult">{{ testResult }}</div>
        <el-button
          @click="testCode"
          style="background-color: #9999ff; color: #fff"
          >运行测试</el-button
        >
      </el-form-item>

      <div class="button-group" style="display: flex; justify-content: center">
        <el-button
          type="primary"
          style="width: 185px; margin: 0 20px"
          class="form-button"
          @click="submitFn"
        >
          <span>确定</span>
        </el-button>
      </div>
    </el-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
// import { runScript } from '@/api/scriptis'
import { PrismEditor } from 'vue-prism-editor'
import 'vue-prism-editor/dist/prismeditor.min.css' // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from 'prismjs/components/prism-core'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/themes/prism-tomorrow.css' // import syntax highlighting styles
export default {
  components: {
    PrismEditor
  },
  props: {
    state: {
      type: Boolean,
      default: false
    },
    row: Object,
    roles: Array
  },
  watch: {
    // row(newData) {
    //   console.log("watch", newData);
    // },
    row: {
      handler(newData) {
        console.log(newData)
        if (!newData) return

        // console.log("watch", newData);
        this.formData = newData
        // console.log(newData.state)
      },
      immediate: true
    }
  },
  data() {
    return {
      testResult: '',
      lineNumbers: true, // true为编辑模式， false只展示不可编辑
      // 表单配置
      formData: {
        // scriptName: '',
        // inputExample: '',
        // scriptBody: ''
      },
      rules: {
        scriptName: [
          { required: true, message: '脚本名称必填', trigger: 'blur' }
        ],
        inputExample: [
          { required: true, message: '脚本示例必填', trigger: 'blur' }
        ],
        scriptBody: [
          { required: true, message: '脚本内容必填', trigger: 'blur' }
        ]
      },

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    highlighter(code) {
      return highlight(code, languages.js) //returns html
    },
    codeChanged(_code) {
      window.console.log(_code)
    },
    // 运行测试代码
    testCode() {
      if (!this.formData.scriptBody) {
        this.$message({
          message: '脚本内容不能为空',
          type: 'error'
        })
        return
      }
      if (!this.formData.inputExample) {
        this.$message({
          message: '脚本示例不能为空',
          type: 'error'
        })
        return
      }
      let result = ''
      let testfunc
      let runstr = 'testfunc = function' + this.formData.scriptBody
      eval(runstr)
      result = testfunc(this.formData.inputExample)
      this.testResult = result
      // this.$loading({
      //   text: '脚本运行中'
      // })
      // // let infos = JSON.parse(JSON.stringify(formData))
      // let runparams = {
      //   inputExample: this.formData.inputExample,
      //   scriptBody: this.formData.scriptBody
      //   // status: infos.status,
      //   // inputExample: infos.inputExample
      // }
      // runScript(runparams).then((res) => {
      //   console.log(res.data, '运行')
      //   if (res.code == 200) {
      //     this.testResult = res.data
      //     // this.$message({
      //     //   message: '添加成功',
      //     //   type: 'success'
      //     // })
      //     // this.$router.go(-1)
      //   } else {
      //     this.$message({
      //       message: res.data,
      //       type: 'error'
      //     })
      //   }
      // })
      // this.$loading().close()
    },
    handleClose() {
      this.testResult = ''
      this.$emit('close')
    },
    submitFn() {
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          this.$emit('confirm', this.formData)
        }
      })
      console.log('更新数据处理', this.formData)
    }
  }
}
</script>

<style></style>
